(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myro-product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.dataset.psInit === '1') return;
      root.dataset.psInit = '1';

      var track = root.querySelector('[data-ps-track]');
      var prevBtn = root.querySelector('[data-ps-prev]');
      var nextBtn = root.querySelector('[data-ps-next]');
      var isGrid = root.dataset.layout === 'grid';
      var autoplay = !isGrid && root.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 4000;
      var loop = root.dataset.loop === 'true';
      var autoplayTimer = null;
      var paused = false;

      function getStep() {
        var first = track && track.querySelector('[data-ps-card]');
        if (!first) return track ? track.clientWidth : 0;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0);
        return first.getBoundingClientRect().width + gap;
      }

      function scrollByStep(dir) {
        if (!track) return;
        var step = getStep();
        var max = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + dir * step;
        if (loop) {
          if (next > max + 2) next = 0;
          else if (next < -2) next = max;
        }
        track.scrollTo({ left: next, behavior: 'smooth' });
      }

      if (!isGrid) {
        if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); resetAutoplay(); });
        if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); resetAutoplay(); });
      }

      function startAutoplay() {
        if (!autoplay || !track) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          if (paused) return;
          var max = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= max - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            scrollByStep(1);
          }
        }, autoplaySpeed);
      }
      function stopAutoplay() {
        if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
      }
      function resetAutoplay() { if (autoplay) startAutoplay(); }

      if (!isGrid) {
        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
        document.addEventListener('visibilitychange', function () {
          paused = document.hidden;
        });
      }

      // Per-card image + variant + add-to-cart logic
      root.querySelectorAll('[data-ps-card]').forEach(function (card) {
        var stage = card.querySelector('[data-ps-img-stage]');
        var images = stage ? stage.querySelectorAll('.ps-img') : [];
        var dots = card.querySelectorAll('[data-ps-img-dot]');
        var imgPrev = card.querySelector('[data-ps-img-prev]');
        var imgNext = card.querySelector('[data-ps-img-next]');
        var atcForm = card.querySelector('[data-ps-atc-form]');
        var atcIdInput = card.querySelector('[data-ps-atc-id]');
        var atcBtn = card.querySelector('[data-ps-atc-btn]');
        var atcLabel = card.querySelector('[data-ps-atc-label]');
        var current = 0;

        function showImage(idx) {
          if (!images.length) return;
          if (idx < 0) idx = images.length - 1;
          if (idx >= images.length) idx = 0;
          images.forEach(function (im, i) { im.classList.toggle('is-active', i === idx); });
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          current = idx;
        }

        if (imgPrev) imgPrev.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          showImage(current - 1);
        });
        if (imgNext) imgNext.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          showImage(current + 1);
        });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            showImage(parseInt(dot.dataset.imgIndex, 10) || 0);
          });
        });

        // Variants — switch image and update cart variant id
        card.querySelectorAll('[data-ps-variants]').forEach(function (group) {
          var btns = group.querySelectorAll('[data-ps-variant]');
          btns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault(); e.stopPropagation();
              btns.forEach(function (b) { b.classList.remove('is-active'); });
              btn.classList.add('is-active');
              var vid = btn.dataset.variantId;
              if (!vid) return;
              if (atcIdInput) atcIdInput.value = vid;
              for (var i = 0; i < images.length; i++) {
                var ids = (images[i].dataset.variantIds || '').split(',').filter(Boolean);
                if (ids.indexOf(vid) !== -1) { showImage(i); break; }
              }
            });
          });
        });

        // Add to cart (AJAX)
        if (atcForm && atcBtn) {
          atcForm.addEventListener('submit', function (e) {
            e.preventDefault();
            if (atcBtn.disabled) return;
            var originalLabel = atcLabel ? atcLabel.textContent : '';
            atcBtn.disabled = true;
            atcBtn.classList.add('is-adding');
            if (atcLabel) atcLabel.textContent = 'Adding...';

            var fd = new FormData(atcForm);
            fetch(atcForm.action, {
              method: 'POST',
              body: fd,
              headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
            })
              .then(function (res) { return res.json().catch(function () { return {}; }); })
              .then(function (data) {
                atcBtn.classList.remove('is-adding');
                if (data && data.status && data.status >= 400) {
                  if (atcLabel) atcLabel.textContent = data.message || 'Error';
                  setTimeout(function () {
                    atcBtn.disabled = false;
                    if (atcLabel) atcLabel.textContent = originalLabel;
                  }, 1800);
                  return;
                }
                atcBtn.classList.add('is-added');
                if (atcLabel) atcLabel.textContent = 'Added';
                document.dispatchEvent(new CustomEvent('ps:cart:added', { detail: data }));
                setTimeout(function () {
                  atcBtn.classList.remove('is-added');
                  atcBtn.disabled = false;
                  if (atcLabel) atcLabel.textContent = originalLabel;
                }, 1600);
              })
              .catch(function () {
                atcBtn.classList.remove('is-adding');
                atcBtn.disabled = false;
                if (atcLabel) atcLabel.textContent = originalLabel;
              });
          });
        }
      });

      startAutoplay();
    }

    function initAll() {
      document.querySelectorAll('[data-product-slider]').forEach(initSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
